import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const SchedulingSection = () => {
  useEffect(() => {
    // Dynamically load the Sayify widget script to ensure the container exists
    const script = document.createElement('script');
    script.src = "https://resource.sayify.pro/cdn/widget.js";
    script.async = true;
    script.setAttribute('data-slug', 'customer-inquiry');
    script.setAttribute('data-mode', 'inline-form');
    script.setAttribute('data-base-url', 'https://crcnu.sayify.pro');
    script.setAttribute('data-label', 'Feedback');
    script.setAttribute('data-color', '#C86A4A');
    script.setAttribute('data-position', 'bottom-right');
    script.setAttribute('data-description', 'Share your feedback by voice');
    script.setAttribute('data-inline-height', '600');
    script.setAttribute('data-auto-height', 'true');
    script.setAttribute('data-container', 'sayify-widget-container');
    
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      // Also clean up any injected elements in the container
      const container = document.getElementById('sayify-widget-container');
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <section id="scheduling" className="py-20 bg-gray-50">
      <div className="w-4/5 mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Schedule Your Free VoIP Savings Review
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Discover how much you can save by switching to 3CX. Our local experts will analyze your current setup and show you a better way.
          </p>
        </motion.div>

        <motion.div
          className="bg-white rounded-2xl shadow-lg p-4 md:p-8"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {/* Sayify Widget Container */}
          <div 
            id="sayify-widget-container" 
            className="w-full min-h-[610px] bg-gray-50 rounded-xl overflow-hidden"
          >
            {/* The widget script will inject the form here */}
            
          </div>
        </motion.div>

        <motion.div
          className="text-center mt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-500 text-sm">
            ✓ No obligation consultation ✓ Local Hudson Valley support ✓ Same-day response
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default SchedulingSection;